import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Container } from "@material-ui/core";
import "../App.css";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
// import Typing from "react-typing-animation";

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
    minWidth: "100vw",
    backgroundSize: "cover",
    // background:
    //   "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%), #272626",
    background: "#F4f4f4",
    color: "white",
    position: "relative",
  },
  logo: {
    height: "calc(64px + 4vmax)",
    width: "calc(64px + 4vmax)",
    margin: "5px",
    // filter: "invert(1)",
  },
  imagetitle: {
    height: "calc(100px + 20vw)",
    width: "auto",
    maxWidth: "90vw",
    marginLeft: "-2vw",
    // filter: "invert(1)",
  },
  header: {
    margin: "auto",
    fontSize: "calc(32px + 8vw)",
    paddingTop: "7vh",
    fontFamily: "Lora",
    fontWeight: "bold",
    color: "#000000",
    marginBottom: "0vh",
  },
  desc: {
    fontSize: "calc(5px + 3vmax)",
  },
  innerContainer: {
    marginLeft: "",
  },
  subheader: {
    fontSize: "calc(8px + 1.5vw)",
    fontFamily: "Lora",
    fontWeight: "bold",
    marginBottom: "5%",
    color: "#000000",
  },
  boxCover: {
    height: "30vh",
    width: "30vh",
    borderRadius: "5px",
  },
  icon: {
    fontSize: "calc(16px + 8vmax)",
    filter: "invert(1)",
  },
  bottomContainer: {
    width: "100%",
    textAlign: "center",
    position: "absolute",
    bottom: "10px",
    marginLeft: "-16px",
  },
  imageContainer: {
    width: "calc(680px + 4vmax)",
    position: "absolute",
    bottom: "0px",
    marginBottom: "-5px",
    right: "-5%",

    // background: 'black'
  },
  house: {
    position: "relative",
    width: "calc(210px + 4vmax)",
    zIndex: "1",
  },
  building: {
    position: "relative",
    width: "calc(210px + 4vmax)",
    zIndex: "0",
    marginLeft: "-5vw",
  },
});

const Hero = () => {
  const classes = useStyles();
  const [open2, setOpen2] = React.useState(window.scrollY);

  React.useEffect(() => {
    window.onscroll = () => {
      const newScrollHeight = Math.ceil(window.scrollY / 1) * 1;
      if (open2 !== newScrollHeight) {
        setOpen2(newScrollHeight);
      }
    };
  }, []);

  const opacity2 = 1 //Math.min(200 / open2, 1);

  return (
    <Container
      style={{ opacity: opacity2 }}
      maxWidth="false"
      className={classes.root}
    >
      <a href="https://michigandaily.com">
        <img
          src={require("../images/TMD.png")}
          className={classes.logo}
          alt="cover"
        />
      </a>

      <Container className={classes.innerContainer}>
        {/* <Typing> */}
        <Typography
          style={{ opacity: opacity2 }}
          className={classes.header}
          gutterBottom
        >
          the statement
        </Typography>

        {/* <img
          src={require("../images/housingtitle.png")}
          className={classes.imagetitle}
          alt="cover"
        /> */}
        {/* </Typing> */}

        <Typography style={{ opacity: opacity2 }} className={classes.subheader}>
          The Michigan Daily’s longform magazine
        </Typography>

        {/* <Container>
          <div style={{ opacity: opacity2 }} className={classes.imageContainer}>
            <img
              src={require("../images/house.png")}
              className={classes.house}
              alt="cover"
            />
            <img
              src={require("../images/building1.png")}
              className={classes.building}
              alt="cover"
            />

            <img
              src={require("../images/building2.png")}
              className={classes.building}
              alt="cover"
            />
          </div>
        </Container> */}
      </Container>
      <div style={{ opacity: opacity2 }} className={classes.bottomContainer}>
        <KeyboardArrowDownIcon className={classes.icon} />
      </div>
    </Container>
  );
};

export default Hero;
